import { Amplify } from 'aws-amplify';
import { env } from 'env';

const {
  // @ts-ignore
  REACT_APP_COGNITO_CLIENT_ID,
  // @ts-ignore
  REACT_APP_COGNITO_USERPOOL_ID,
  // @ts-ignore
  REACT_APP_COGNITO_DOMAIN,
} = env;

export const configureAuth = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolClientId: REACT_APP_COGNITO_CLIENT_ID,
        userPoolId: REACT_APP_COGNITO_USERPOOL_ID,

        loginWith: {
          oauth: {
            domain: REACT_APP_COGNITO_DOMAIN,
            scopes: ['openid'],
            // scopes: Object.values(ParticipantScopes),
            redirectSignIn: [window.location.origin],
            redirectSignOut: [window.location.origin],
            responseType: 'code',
          },
        },
      },
    },
  });
};
